import axios from 'axios'

const API_URL = 'https://spflqnjnzf.execute-api.us-east-2.amazonaws.com/stage/'

// In-memory only, so switching pages doesn't refetch within a visit
const cache = {}

function byDateDesc(blob1, blob2) {
  if (blob1.posted_date < blob2.posted_date) {
    return 1
  }
  if (blob1.posted_date > blob2.posted_date) {
    return -1
  }
  return 0
}

export function getSection(section) {
  if (!cache[section]) {
    cache[section] = axios.get(API_URL + section)
      .then(res => res.data.Items.sort(byDateDesc))
      .catch(error => {
        delete cache[section]
        throw error
      })
  }
  return cache[section]
}

export function formatDate(postedDate) {
  const [year, month, day] = String(postedDate).split('-').map(Number)
  if (!year || !month || !day) {
    return postedDate
  }
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric'
  })
}
